import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "New Relic",
  "description": "New Relic Dashboard Setup"
};
export let structuredData = {
  "contents": [{
    "heading": "prerequisites",
    "content": "Rudderstack events or entities (python, node, browser) setup are already done."
  }, {
    "heading": "prerequisites",
    "content": "Logs are being processed in new relic."
  }, {
    "heading": "setup",
    "content": "Go to dashboards (keyboard shortcut - G 1)"
  }, {
    "heading": "setup",
    "content": "Click on Create a dashboard"
  }, {
    "heading": "setup",
    "content": "Two Options:"
  }, {
    "heading": "setup",
    "content": "Browse pre built dashboards and customize (Recommended)"
  }, {
    "heading": "setup",
    "content": "Custom based"
  }, {
    "heading": "pre-built-dashboard",
    "content": "For instance nodejs, search for nodejs dashboard, select prebuilt dashboard."
  }, {
    "heading": "pre-built-dashboard",
    "content": "Give name and click on create."
  }, {
    "heading": "pre-built-dashboard",
    "content": "You will be redirected to the prebuilt dashboard."
  }, {
    "heading": "pre-built-dashboard",
    "content": "Some dashboards will have variable for setting filters, by defaults it takes all the logs from nodejs app."
  }, {
    "heading": "pre-built-dashboard",
    "content": "To customize, do this (and WHERE appName = 'your-app') for each graph and apply changes and then save"
  }, {
    "heading": "pre-built-dashboard",
    "content": "You have a detailed dashboard setup"
  }, {
    "heading": "custom-dashboard",
    "content": "Prerequisite: Familiarity with New Relic Query Language (NRQL)."
  }, {
    "heading": "custom-dashboard",
    "content": "Click on \"Add a new chart\"."
  }, {
    "heading": "custom-dashboard",
    "content": "Switch to the NRQL editor."
  }, {
    "heading": "custom-dashboard",
    "content": "Enter your NRQL queries to fetch and visualize specific data. For example:"
  }, {
    "heading": "custom-dashboard",
    "content": "Run the query to preview the results."
  }, {
    "heading": "custom-dashboard",
    "content": "Choose the desired visualization type (e.g., line chart, bar chart)."
  }, {
    "heading": "custom-dashboard",
    "content": "Save the chart to add it to your dashboard."
  }],
  "headings": [{
    "id": "prerequisites",
    "content": "Prerequisites"
  }, {
    "id": "setup",
    "content": "Setup"
  }, {
    "id": "pre-built-dashboard",
    "content": "Pre Built Dashboard"
  }, {
    "id": "custom-dashboard",
    "content": "Custom Dashboard"
  }]
};
export const toc = [{
  depth: 2,
  url: "#prerequisites",
  title: _jsx(_Fragment, {
    children: "Prerequisites"
  })
}, {
  depth: 2,
  url: "#setup",
  title: _jsx(_Fragment, {
    children: "Setup"
  })
}, {
  depth: 3,
  url: "#pre-built-dashboard",
  title: _jsx(_Fragment, {
    children: "Pre Built Dashboard"
  })
}, {
  depth: 3,
  url: "#custom-dashboard",
  title: _jsx(_Fragment, {
    children: "Custom Dashboard"
  })
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    ol: "ol",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "prerequisites",
      children: "Prerequisites"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Rudderstack events or entities (python, node, browser) setup are already done."
      }), "\n", _jsx(_components.li, {
        children: "Logs are being processed in new relic."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "setup",
      children: "Setup"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Go to dashboards (keyboard shortcut - ", _jsx(_components.code, {
          children: "G 1"
        }), ")"]
      }), "\n", _jsx(_components.li, {
        children: "Click on Create a dashboard"
      }), "\n", _jsxs(_components.li, {
        children: ["Two Options:", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Browse pre built dashboards and customize (Recommended)"
          }), "\n", _jsx(_components.li, {
            children: "Custom based"
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "pre-built-dashboard",
      children: "Pre Built Dashboard"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "For instance nodejs, search for nodejs dashboard, select prebuilt dashboard."
      }), "\n", _jsx(_components.li, {
        children: "Give name and click on create."
      }), "\n", _jsx(_components.li, {
        children: "You will be redirected to the prebuilt dashboard."
      }), "\n", _jsx(_components.li, {
        children: "Some dashboards will have variable for setting filters, by defaults it takes all the logs from nodejs app."
      }), "\n", _jsxs(_components.li, {
        children: ["To customize, do this (", _jsx(_components.code, {
          children: "and WHERE appName = 'your-app'"
        }), ") for each graph and apply changes and then save"]
      }), "\n", _jsx(_components.li, {
        children: "You have a detailed dashboard setup"
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "custom-dashboard",
      children: "Custom Dashboard"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.strong, {
              children: "Prerequisite"
            }), ": Familiarity with New Relic Query Language (NRQL)."]
          }), "\n", _jsxs(_components.li, {
            children: ["Click on ", _jsx(_components.strong, {
              children: "\"Add a new chart\""
            }), "."]
          }), "\n", _jsxs(_components.li, {
            children: ["Switch to the ", _jsx(_components.strong, {
              children: "NRQL editor"
            }), "."]
          }), "\n", _jsxs(_components.li, {
            children: ["Enter your NRQL queries to fetch and visualize specific data. For example:", "\n", _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes github-light github-dark",
                style: {
                  "--shiki-light": "#24292e",
                  "--shiki-dark": "#e1e4e8",
                  "--shiki-light-bg": "#fff",
                  "--shiki-dark-bg": "#24292e"
                },
                tabIndex: "0",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "#D73A49",
                        "--shiki-dark": "#F97583"
                      },
                      children: "SELECT"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#005CC5",
                        "--shiki-dark": "#79B8FF"
                      },
                      children: " count"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#24292E",
                        "--shiki-dark": "#E1E4E8"
                      },
                      children: "("
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#D73A49",
                        "--shiki-dark": "#F97583"
                      },
                      children: "*"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#24292E",
                        "--shiki-dark": "#E1E4E8"
                      },
                      children: ") "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#D73A49",
                        "--shiki-dark": "#F97583"
                      },
                      children: "FROM"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#D73A49",
                        "--shiki-dark": "#F97583"
                      },
                      children: " Transaction"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#D73A49",
                        "--shiki-dark": "#F97583"
                      },
                      children: " WHERE"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#24292E",
                        "--shiki-dark": "#E1E4E8"
                      },
                      children: " appName "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#D73A49",
                        "--shiki-dark": "#F97583"
                      },
                      children: "="
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#032F62",
                        "--shiki-dark": "#9ECBFF"
                      },
                      children: " 'your-app-name'"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#24292E",
                        "--shiki-dark": "#E1E4E8"
                      },
                      children: " SINCE "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#005CC5",
                        "--shiki-dark": "#79B8FF"
                      },
                      children: "30"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#D73A49",
                        "--shiki-dark": "#F97583"
                      },
                      children: " minutes"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "#24292E",
                        "--shiki-dark": "#E1E4E8"
                      },
                      children: " ago"
                    })]
                  })
                })
              })
            }), "\n"]
          }), "\n", _jsx(_components.li, {
            children: "Run the query to preview the results."
          }), "\n", _jsx(_components.li, {
            children: "Choose the desired visualization type (e.g., line chart, bar chart)."
          }), "\n", _jsx(_components.li, {
            children: "Save the chart to add it to your dashboard."
          }), "\n"]
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
